import { Box, Divider } from "@mui/material";
import { PageTitle } from "../../App/Components/PageTitle/PageTitle";
import { useGroupProfileContext } from "../State/GroupProfileContext";
import { DisplayGroupDetails } from "./DisplayGroupDetails";
import GroupButtons from "./GroupButtons";

export default function GroupHeader() {
  const { group } = useGroupProfileContext();
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          md: "fit-content(33%) 1px minmax(min-content, 66%)",
        },
        gap: { xs: 1, md: 2 },
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0,
          alignItems: { xs: "center", md: "flex-start" },
          justifyContent: "center",
        }}
      >
        <PageTitle
          sx={{
            width: 1,
            lineHeight: 1,
            color: "secondary.main",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          {group.name}
        </PageTitle>
        <GroupButtons />
      </Box>
      <Divider
        orientation="vertical"
        flexItem
        variant="middle"
        sx={{ display: { xs: "none", md: "block" } }}
      />
      <DisplayGroupDetails />
    </Box>
  );
}
